import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { hideModal } from '../../../../actions/modal';
import TheoryList from '../../../theory-list';
import Stack from '../../../stack';

import Modal from '../..';
import { Content, ModalBodyContainer } from '../../components';

export const TheoriesModalBody = ({ onClose, theoryGroupId, theme, microTheme, theories }) => {
    return (
        <Modal title="Aiuti di teoria" onClose={onClose}>
            <ModalBodyContainer>
                <Content>
                    <Stack gap="small">
                        <>
                            <span className="body-3-sb">{microTheme}</span>
                            <span className="body-3">{theme}</span>
                        </>
                        <TheoryList microThemeId={theoryGroupId} theories={theories} />
                    </Stack>
                </Content>
            </ModalBodyContainer>
        </Modal>
    );
};

TheoriesModalBody.propTypes = {
    onClose: PropTypes.func,
    theoryGroupId: PropTypes.string,
    theme: PropTypes.string,
    microTheme: PropTypes.string,
    theories: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        theoryGroupId: state.modal.theory.theoryGroupId,
        theme: state.modal.theory.theme,
        microTheme: state.modal.theory.microTheme,
        theories: state.modal.theory.theories,
    };
};

const actionCreators = {
    onClose: hideModal,
};

export default connect(mapStateToProps, actionCreators)(TheoriesModalBody);
